import requester from './requester';

// eslint-disable-next-line import/prefer-default-export
export function getLocalResource(relativeUrl) {
  return requester.get(`${relativeUrl}`, {
    noCache: true
  });
}

export async function getLocalJsonResource(relativeUrl) {
  const response = await getLocalResource(relativeUrl);
  const responseText = await response.text(); // fix for preview
  if (!responseText || responseText.length === 0) {
    return {};
  }

  return JSON.parse(responseText);
}
